import { Helmet } from "react-helmet-async";
import Screen from "../../Layouts/Screen/Screen";
import "./style.css"
import ItemList from "../../../components/ItemList/ItemList";
import { Link } from "react-router-dom";
import { t } from "i18next";

const MeaningStamps = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title={t("meaningSeals.title")}>
                <Helmet>
                        <title>Paçoca - {t("meaningSeals.title")}</title>
                        <meta name="description" content={`Paçoca - ${t("meaningSeals.title")}!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, ${t("meaningSeals.title")}, selos, badges}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - ${t("meaningSeals.title")}`}/>
                        <meta property="og:description" content={`Saiba o significado de todos os selos do Paçoca`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - ${t("meaningSeals.title")}`}/>
                        <meta name="twitter:description" content={`Saiba o significado de todos os selos do Paçoca`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/verified.png" height="20" /> {t("meaningSeals.verified.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.verified.description")} <Link to="/verificado">{t("meaningSeals.verified.link")}</Link></p>
                    </div>
                </ItemList>
 
                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/purple.png" height="20" /> {t("meaningSeals.purple.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.purple.description")}</p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/yellow.png" height="20" /> {t("meaningSeals.yellow.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.yellow.description")}</p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img className="img-vefified-company-color" src="/img/selos/black.png" height="20" /> {t("meaningSeals.black.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.black.description")} <Link to="/empresas/solicitar-selo">{t("meaningSeals.black.link")}</Link></p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/gray.png" height="20" /> {t("meaningSeals.gray.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.gray.description")}</p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/autism.png" height="20" /> {t("meaningSeals.autism.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.autism.description")} <Link to="/meus-selos">{t("meaningSeals.autism.link")}</Link></p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/hidden_deficiencies.png" height="20" /> {t("meaningSeals.hidden_deficiencies.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.hidden_deficiencies.description")} <Link to="/meus-selos">{t("meaningSeals.hidden_deficiencies.link")}</Link></p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/lgbt.png" height="20" /> {t("meaningSeals.lgbt.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.lgbt.description")} <Link to="/meus-selos">{t("meaningSeals.lgbt.link")}</Link></p>
                    </div>
                </ItemList>

                <div className="padding-big-screen">
                    <h5 className="mt-4">{t("meaningSeals.teamPacoca")}</h5>
                </div>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/brown.png" height="20" /> {t("meaningSeals.brown.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.brown.description")}</p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/darkBlue.png" height="20" /> {t("meaningSeals.darkBlue.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.darkBlue.description")}</p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/red.png" height="20" /> {t("meaningSeals.red.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.red.description")}</p>
                    </div>
                </ItemList>

                <ItemList>
                    <div className="col-12">
                        <img src="/img/selos/peach.png" height="20" /> {t("meaningSeals.peach.title")}
                        <p style={{marginTop: "3px", marginBottom: 5}}>{t("meaningSeals.peach.description")}</p>
                    </div>
                </ItemList>
            </Screen>
        </>
    );
};

export default MeaningStamps;